
export default {
  data() {
    return {

    }
  },
  components: { 

  },
  methods: 
  {

  },
  mounted () {
    
  }
}
